import Autorizaciones_compras from "../../../views/administrador/Autorizaciones/Autorizaciones_compras";




const routes_autorizaciones = [
  {
    path: "/Autorizaciones_compras",
    name: "Autorizaciones Compras",
    icon: "",
    component: Autorizaciones_compras,
    doNotShow: true,
  },
 
];

export default routes_autorizaciones;
